export default __webpack_public_path__ + "static/cropin-logo-ac697723f12c1278a77aea4ca19d7f8f.png";